import { NgModule } from '@angular/core';

import { NgxResizableModule } from '@3dgenomes/ngx-resizable';

import { AngularMaterialModule } from './angular-material/angular-material.module';
import { CreditsComponent } from './credits/credits.component';
import { AboutDialogComponent } from './dialogs/about-dialog/about-dialog.component';
import { PlaceholderDirective } from './directives/placeholder.directive';
import { TranslateModule } from '@ngx-translate/core';
import { EditableComponent } from './editable/editable.component';
import { EditOnEnterDirective } from './editable/edit-on-enter.directive';
import { EditModeDirective } from './editable/edit-mode.directive';
import { ViewModeDirective } from './editable/view-mode.directive';
import { CommonModule } from '@angular/common';
import { FocusableDirective } from './directives/focusable.directive';
import { ModaleUtenteComponent } from './dialogs/modale-utente/modale-utente.component';
import { ModaleCountdownComponent } from './dialogs/modale-countdown/modale-countdown.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SintexTooltipPipe } from './pipes/sintex-tooltip.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ModaleRisorseComponent } from './dialogs/modale-risorse/modale-risorse.component';
import { ResourceTreeComponent } from './components/resource-tree/resource-tree.component';
import { MatSpinnerOverlayComponent } from './components/mat-spinner-overlay/mat-spinner-overlay.component';
import { GlossaryColorPipe } from './pipes/glossary-color.pipe';
import { RoleColorPipe } from './pipes/role-color.pipe';
import { EditableGlossaryPipe } from './pipes/editable-glossary.pipe';
import { LockableGlossaryPipe } from './pipes/lockable-glossary.pipe';
import { GetTractateTitlePipe } from './pipes/get-tractate-title.pipe';
import { ModaleCercaGlossariComponent } from './dialogs/modale-cerca-glossari/modale-cerca-glossari.component';
import { SelectClickDirective } from './directives/select-click.directive';
import { ContextMenuModule } from 'ngx-contextmenu';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditableTranslationPipe } from './pipes/editable-translation.pipe';
import { CustomEditorModule } from './components/custom-editor/custom-editor.module';
import { NotePersonaliComponent } from './dialogs/note-personali/note-personali.component';
import { UnreferencedGlossaryPipe } from './pipes/unreferenced-glossary.pipe';
import { ShowSeealsoTagPipe } from './pipes/show-seealso-tag.pipe';
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component';
import { DisplayOnlyDialogComponent } from './dialogs/display-only-dialog/display-only-dialog.component';
import { ActiveTreeNodePipe } from './pipes/active-tree-node.pipe';
import { CheckAssignedResourcePipe } from './pipes/check-assigned-resource.pipe';
import { MorphologyTooltipPipe } from './pipes/morphology-tooltip.pipe';
import { UnderlineTokensPipe } from './pipes/underline-tokens.pipe';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { ReplaceUnderscorePipe } from './pipes/replace-underscore.pipe';
import { SpinnerDeterminateComponent } from './components/spinner-determinate/spinner-determinate.component';
import { ReduceIndexPipe } from './pipes/reduce-index.pipe';

@NgModule({
    declarations: [
        CreditsComponent,
        AboutDialogComponent,
        PlaceholderDirective,
        EditableComponent,
        EditOnEnterDirective,
        EditModeDirective,
        ViewModeDirective,
        FocusableDirective,
        ModaleUtenteComponent,
        ModaleCountdownComponent,
        SafeHtmlPipe,
        SintexTooltipPipe,
        ModaleRisorseComponent,
        ResourceTreeComponent,
        MatSpinnerOverlayComponent,
        GlossaryColorPipe,
        RoleColorPipe,
        EditableGlossaryPipe,
        LockableGlossaryPipe,
        GetTractateTitlePipe,
        ModaleCercaGlossariComponent,
        SelectClickDirective,
        EditableTranslationPipe,
        NotePersonaliComponent,
        UnreferencedGlossaryPipe,
        ShowSeealsoTagPipe,
        ConfirmDialogComponent,
        DisplayOnlyDialogComponent,
        ActiveTreeNodePipe,
        CheckAssignedResourcePipe,
        MorphologyTooltipPipe,
        UnderlineTokensPipe,
        ReplaceUnderscorePipe,
        SpinnerDeterminateComponent,
        ReduceIndexPipe,
    ],
    imports: [
        AngularMaterialModule,
        NgxResizableModule,
        TranslateModule,
        CommonModule,
        DragDropModule,
        ContextMenuModule,
        FormsModule,
        ReactiveFormsModule,
        CustomEditorModule,
        ScrollingModule
    ],
    exports: [
        AngularMaterialModule,
        CreditsComponent,
        NgxResizableModule,
        AboutDialogComponent,
        PlaceholderDirective,
        EditableComponent,
        EditOnEnterDirective,
        EditModeDirective,
        ViewModeDirective,
        FocusableDirective,
        ModaleUtenteComponent,
        ModaleCountdownComponent,
        SafeHtmlPipe,
        SintexTooltipPipe,
        DragDropModule,
        ModaleRisorseComponent,
        ResourceTreeComponent,
        MatSpinnerOverlayComponent,
        GlossaryColorPipe,
        RoleColorPipe,
        EditableGlossaryPipe,
        LockableGlossaryPipe,
        GetTractateTitlePipe,
        ModaleCercaGlossariComponent,
        SelectClickDirective,
        CommonModule,
        ContextMenuModule,
        FormsModule,
        ReactiveFormsModule,
        EditableTranslationPipe,
        CustomEditorModule,
        NotePersonaliComponent,
        UnreferencedGlossaryPipe,
        ShowSeealsoTagPipe,
        ConfirmDialogComponent,
        DisplayOnlyDialogComponent,
        MorphologyTooltipPipe,
        UnderlineTokensPipe,
        ScrollingModule,
        ReplaceUnderscorePipe,
        SpinnerDeterminateComponent,
        ReduceIndexPipe
    ],
    providers: [MorphologyTooltipPipe]
})
export class SharedModule { }